import {tradeMovement} from './price-movement';
import {csvCell} from './journal-metrics';
import {isArchived} from './archive-store';

export function buildJournalCSV(trades,accounts,folders={}){
  const accMap={};accounts.forEach(a=>{accMap[a.id]=a.name;});
  const headers=["Date","Instrument","Direction","Result","Entry","SL","TP","Close Price","Return %","Risk %","R Multiple","Points","Pips","R:R","Timeframe","Session","Duration","Confluences","Bias","Setup","Mistakes","Key Takeaway","Emotion","Tags","Account","Main Chart URL","Has Analysis Charts","Collection","Archive Folder"];
  const esc=csvCell;
  const rows=trades.map(t=>[
    t.date,t.instrument,t.direction,t.result,
    t.entry,t.sl,t.tp,t.closePrice,t.returnPct,t.riskPct,(parseFloat(t.riskPct)>0&&Number.isFinite(parseFloat(t.returnPct))?(parseFloat(t.returnPct)/parseFloat(t.riskPct)).toFixed(2):""),tradeMovement(t).unit==='points'?tradeMovement(t).value:'',tradeMovement(t).unit==='pips'?tradeMovement(t).value:'',t.rr,
    t.timeframe,t.session,t.duration,
    (t.confluences||[]).join("|"),
    t.bias||"",
    t.setup||"",
    t.mistakes||"",
    t.keyTakeaway||"",
    t.emotion,t.tags,
    t.accountId?accMap[t.accountId]||"":"",
    t.mainChart?.src||"",
    (t.images||[]).filter(i=>i?.src).length>0?"Yes":"No",
    isArchived(t)?"Archive":"Current journal",isArchived(t)?folders[t.archiveFolderId]?.name||"Saved archive":"",
  ]);
  const csv=[headers,...rows].map(r=>r.map(v=>esc(v)).join(",")).join("\n");
  return csv;
}
